export enum OrganizationId {
  healix = 'healix',
  landg = 'landg',

  internationalpmi = 'internationalpmi',
  occhealthnow = 'occhealthnow',
}
